import { useRef, useState } from "react";
export default function useAudioAutoStopRecorder(silenceTime = 2000, silenceThreshold = 5, onStopRecorder = null) {
    const mediaRecorderRef = useRef(null);
    const analyserRef = useRef(null);
    const audioContextRef = useRef(null);
    const silenceTimer = useRef(null);
    const chunks = useRef([]);
    const rafRef = useRef(null);

    const [recording, setRecording] = useState(false);

    const startRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            audioContextRef.current = new AudioContext();
            const source = audioContextRef.current.createMediaStreamSource(stream);
            analyserRef.current = audioContextRef.current.createAnalyser();
            analyserRef.current.fftSize = 512;
            source.connect(analyserRef.current);

            mediaRecorderRef.current = new MediaRecorder(stream);
            chunks.current = [];

            mediaRecorderRef.current.ondataavailable = (e) => {
                if (e.data.size > 0) chunks.current.push(e.data);
            };

            mediaRecorderRef.current.onstop = () => {
                const blob = new Blob(chunks.current, { type: "audio/mp3" });
                if(onStopRecorder) onStopRecorder(blob);
                stream.getTracks().forEach((t) => t.stop());
                audioContextRef.current?.close();
            };

            mediaRecorderRef.current.start();
            setRecording(true);

            detectSilence();
        } catch (err) {
            ;
        }
    };

    const stopRecording = () => {
        clearTimeout(silenceTimer.current);
        silenceTimer.current = null;
        cancelAnimationFrame(rafRef.current);

        if (mediaRecorderRef.current?.state === "recording") {
            mediaRecorderRef.current.stop();
        }
        setRecording(false);
    };

    const detectSilence = () => {
        const analyser = analyserRef.current;
        const data = new Uint8Array(analyser.fftSize);

        const check = () => {
            analyser.getByteFrequencyData(data);
            const volume = data.reduce((a, b) => a + b) / data.length;

            if (volume < silenceThreshold) {
                if (!silenceTimer.current) {
                    silenceTimer.current = setTimeout(stopRecording, silenceTime);
                }
            } else {
                clearTimeout(silenceTimer.current);
                silenceTimer.current = null;
            }

            if (mediaRecorderRef.current?.state === "recording") {
                rafRef.current = requestAnimationFrame(check);
            }
        };

        check();
    };

    return {
        recording,
        startRecording,
        stopRecording,
    };
}
